
















































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '../../../lib/util'
import AbpBase from '../../../lib/abpbase'
import storeaddressInfo from '@/store/entities/back-storeaddress-list'
import Group from '../../../store/entities/group'
import Enums from '@/lib/enums'
import user from '@/store/entities/userinfo'
@Component
export default class EditUser extends AbpBase {
    @Prop({ type: Boolean, default: false }) value: boolean;
    group: Group = new Group();
    storeaddressList: Array<storeaddressInfo> = [];
    ShopSiteList = Enums.ShopSiteType;
    SiteList = Enums.SiteSType;
    user: Array<user> = [];
    selectuser: user = new user();
    async getData() {
        await this.$store.dispatch({
            type: 'backstoreaddress/getAll',
            data: {}
        })
        var a = new storeaddressInfo();
        //a.id = null;
        this.storeaddressList = this.$store.state.backstoreaddress.list.filter(function (item) { return item.whetherEffective == true });
        //this.storeaddressList.push(a);

    }
    async getUser() {
        
        this.user = await this.$store.dispatch({
            type: 'user/getUserList',
            data: {}
        });
        if (this.user.length > 0) {
            var data = this.user.filter(function (item) { return item.id == abp.session.userId });
         
            if (data.length > 0) {
                this.selectuser.id = data[0].id;
            }
        }

    }
    created() {
        this.getData();
        this.getUser();
        
    }
    haspression() {

    }
    visibleChange(value: boolean) {
        if (!value) {
            this.$emit('input', value);
        } else {
            this.group = Util.extend(true, {}, this.$store.state.group.editGroup);
            //this.group.crossBorderSites = [4,6];
            //this.group.abroadWarehouses = [1,3];
            //this.group.nativeSites = [2,7];
            //this.group.groupPersonnels = [4,146];
        }
    }

    save() {
        this.group.isOk = 0;
        (this.$refs.groupForm as any).validate(async (valid: boolean) => {
            if (valid ) {
                await this.$store.dispatch({
                    type: 'group/updateGroup',
                    data: this.group
                });
                (this.$refs.groupForm as any).resetFields();
                this.$emit('save-success');
                this.$emit('input', false);
            } 
        })
    }
    cancel() {
        (this.$refs.groupForm as any).resetFields();
        this.$emit('input', false);
    }
    groupRule = {
        groupName: [{ required: true, message: "分组名称不能为空", trigger: 'blur' }],
    }
}
